const nav = [
  {
    path: 'users.list',
    icon: 'mdi-account-circle',
    title: 'Users',
  },
  {
    path: 'property.list',
    icon: 'mdi-home-city',
    title: 'Property',
  },
  {
    path: 'preference.list',
    icon: 'mdi-bookmark-multiple-outline',
    title: 'Preference',
  },
  {
    path: 'message.list',
    icon: 'mdi-chat',
    title: 'Messages',
  },
];

const state = () => ({
  nav: nav,
});

export default {
  namespaced: true,
  state: state,
};
